import pt from 'prop-types';
import React from 'react';
import { combine } from '../../../helpers/styles';
import ifDesignAwardGold from './badges/if-designaward-gold.svg';
import ifDesignAward from './badges/if-designaward.svg';
import ifTopLabel from './badges/if-top-label.svg';
import taipeiCycleAwards2023 from './badges/taipeiCycleAwards2023.svg';
import DesignAward from './components/designAward';
import GoldAward from './components/goldAward';
import SocialImpact from './components/socialImpact';
import TalentAward from './components/talentAward';
import TaipeiCycleAward from './components/taipeiCycleAward';
import * as styles from './styles.module.scss';

const AwardBadge = ({ name, year, className, trackingId }) => {
  if (!name) {
    return null;
  }

  const staticBadges = {
    ifDesignAward,
    ifDesignAwardGold,
    ifTopLabel,
    taipeiCycleAwards2023,
  };

  const StaticBadge = staticBadges[name];

  if (StaticBadge)
    return (
      <StaticBadge
        className={combine(
          className,
          !['ifTopLabel', 'taipeiCycleAwards2023'].includes(name) &&
            styles.staticBadge
        )}
      />
    );

  const dynamicBadges = {
    ifDesignRed2021: (
      <DesignAward year={year} className={className} trackingId={trackingId} />
    ),
    ifDesignGold2021: (
      <GoldAward year={year} className={className} trackingId={trackingId} />
    ),
    ifSocialImpactPrize2021: (
      <SocialImpact year={year} className={className} trackingId={trackingId} />
    ),
    ifTalentAward2021: (
      <TalentAward year={year} className={className} trackingId={trackingId} />
    ),
    taipeiCycleAward: <TaipeiCycleAward year={year} className={className} />,
  };

  if (dynamicBadges[name]) return dynamicBadges[name];

  return null;
};

AwardBadge.propTypes = {
  name: pt.string.isRequired,
  year: pt.number,
  className: pt.string,
  trackingId: pt.bool,
};

AwardBadge.defaultProps = {
  name: 'taipeiCycleAwards2023',
  className: '',
  year: new Date().getFullYear(),
  trackingId: false,
};

export default AwardBadge;
